import React from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    left: 0,
    fontWeight: theme.typography.fontWeightBold,
    height: "100%",
    width: "30px",
    backgroundColor: "#000",
    color: "#fff",
    writingMode: "vertical-rl",
    textOrientation: "mixed",
    transform:  "rotate(-180deg)"
  },
}));

const SideBanner = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      Punkte, Bußgeld oder Fahrverbot abwenden
    </Box>
  );
};

export default SideBanner;
